/**
 * Which stager a room gets: 'kitchen', 'bathroom', or null.
 *
 * Kitchen is decided the way the kitchen layout generator decides it
 * (`isKitchenRoom`, kitchen-assembly/layoutKitchen.js): a DECLARED kitchen
 * kind, not a guess from the room's name, and not a bathroom the scan
 * mislabelled (`isSpuriousKitchen`). Its two primitives are imported directly
 * rather than `isKitchenRoom` itself, which would pull the generator's
 * cabinet builders into the web bundle; a test keeps the two in step.
 *
 * Bathroom keeps `resolveRoomKind`, which includes the name fallback, so the
 * set of rooms that get bathroom staging is exactly what it was before
 * kitchens existed.
 *
 * Every room kind in an open-plan room counts: a living/dining/kitchen room is
 * staged as a kitchen (Megan, 2026-10-18), on its counters only.
 */

const {
  resolveRoomKind,
  resolveDeclaredRoomKind,
} = require('../rooms/roomKind');
const { isSpuriousKitchen } = require('../room-fixtures');

function stagingKindOf(room) {
  if (!room) return null;
  if (resolveDeclaredRoomKind(room).has('kitchen') && !isSpuriousKitchen(room))
    return 'kitchen';
  if (resolveRoomKind(room).has('bathroom')) return 'bathroom';
  return null;
}

module.exports = { stagingKindOf };
